import { useState } from 'react';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import Implement from 'components/Implement';
import PrimaryButton from 'components/buttons/PrimaryButton';
import CaptionText from 'components/text/CaptionText';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import LogServiceModal from './components/LogServiceModal';
import ServiceLogHistory from './components/ServiceLogHistory';
import { LOG_SERVICE_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneServiceLogTab: FunctionComponent<Props> = ({
    className = '',
    drone,
    onServiceSaved,
    testId = TEST_ID
}) => {
    const { entries, isLoading, refetch } = useData({ drone });
    const { LOG_SERVICE, SERVICE_HISTORY, UPCOMING } = useTranslation();

    const [isLogServiceOpen, setIsLogServiceOpen] = useState(false);

    const handleLogServiceClick = () => setIsLogServiceOpen(true);

    const handleLogServiceClose = () => setIsLogServiceOpen(false);

    const handleServiceSaved = () => {
        refetch();
        onServiceSaved?.();
    };

    return (
        <VerticalContainer className={`${className} ${styles.droneServiceLogTab}`} testId={testId}>
            <VerticalContainer className={styles.section}>
                <CaptionText className={styles.sectionTitle} text={UPCOMING} />

                <Implement />
            </VerticalContainer>

            <VerticalContainer className={styles.section}>
                <CaptionText className={styles.sectionTitle} text={SERVICE_HISTORY} />

                <ServiceLogHistory entries={entries} isLoading={isLoading} />
            </VerticalContainer>

            <PrimaryButton
                className={styles.logServiceButton}
                onClick={handleLogServiceClick}
                testId={LOG_SERVICE_TEST_ID}
                text={LOG_SERVICE}
            />

            {isLogServiceOpen && (
                <LogServiceModal
                    assetId={drone.id}
                    onClose={handleLogServiceClose}
                    onSaved={handleServiceSaved}
                />
            )}
        </VerticalContainer>
    );
};

export default DroneServiceLogTab;
